export interface ApiErrorBody {
  error?: string
  errorType?: string
  errors?: string[]
}

export interface MessageResponse {
  message: string
}

interface ApiServiceErrorOptions {
  status: number
  errorType: string
  message: string
  errors?: string[]
  data?: unknown
}

export class ApiServiceError extends Error {
  readonly status: number

  readonly errorType: string

  readonly errors: string[]

  readonly data: unknown

  constructor({ status, errorType, message, errors = [], data }: ApiServiceErrorOptions) {
    super(message)
    this.name = 'ApiServiceError'
    this.status = status
    this.errorType = errorType
    this.errors = errors
    this.data = data
  }
}

export const isApiServiceError = (error: unknown): error is ApiServiceError =>
  error instanceof ApiServiceError
